﻿import { Component, OnInit } from '@angular/core';

import { RestService } from 'src/app/_services/rest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/_services/util.service';

@Component({ templateUrl: 'resumen.component.html' })
export class ResumenComponent implements OnInit {

    params: any;

    anio: any;

    postaPorCategoria: boolean = false;

    interhouses: boolean = false;

    constructor(private restService: RestService, private router: Router, private route: ActivatedRoute, private utilService: UtilService) {
        this.route.queryParams.subscribe(params => {
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = (new Date()).getFullYear();
            }
            this.restService.getParam('posta.por.categoria').subscribe(data => {
                this.postaPorCategoria = data.valor.toUpperCase() === 'TRUE';
                this.loadAll();
            })
            this.restService.getParam('cargar.detalle.interhouses').subscribe(data => {
                this.interhouses = "true" === data.valor.toLowerCase();
            });
        });
    }

    ngOnInit() {
    }


    private loadAll() {
        this.restService.getAll('/rest-api/user/resultado/resumen?anio=' + this.anio).subscribe(data => {
            this.params = data;
        });
    }


    valor(cat, dep, sex): number {
        let resp = 0;
        this.params.data.forEach(r => {
            if (r.categoriaDeporte.categoria.id === cat.id && r.categoriaDeporte.deporte.id === dep.id && r.sexo.id === sex.id) {
                resp = r.cantidad;
            }
        });
        return resp;
    }

    getCategoriaDeporte(cat, dep): any {
        let resp = 0;
        this.params.categoriaDeporte.forEach(r => {
            if (r.categoria.id === cat.id && r.deporte.id === dep.id) {
                resp = r;
            }
        });
        return resp;
    }

    getDeporte(id: number): Array<Object> {
        const resp = [];
        this.params.deporte.forEach(d => {
            if (d.id == id) {
                resp.push(d);
            }
        });
        return resp
    }

    esDeporte(cat, dep): boolean {
        let resp = false;
        this.params.data.forEach(r => {
            if (r.categoriaDeporte.categoria.id === cat.id && r.categoriaDeporte.deporte.id === dep.id) {
                resp = true;
            }
        });
        return resp;
    }

    esInterhouse(cat, dep, sex): boolean{
        let resp = false;
        this.params.data.forEach(r => {
            if (r.categoriaDeporte.categoria.id === cat.id && r.categoriaDeporte.deporte.id === dep.id) {
                resp = (r.categoriaDeporte.deporte.boys && sex.id == 1) || (r.categoriaDeporte.deporte.girls && sex.id == 2);
            }
        });
        return resp;
    }

    cargar(cat, dep, sex) {
        this.router.navigate(['/user/cargarResultado/'],
            { queryParams: { 'categoria': this.getCategoriaDeporte(cat, dep).id, 'sexo': sex.id, 'anio': this.anio } });
    }

    cargarInterhouses(cat, dep, sex) {
        this.router.navigate(['/user/cargarInterhouse/'],
            { queryParams: { 'categoria': this.getCategoriaDeporte(cat, dep).id, 'sexo': sex.id, 'anio': this.anio } });
    }

    getGrado(categoria: any, sexo:any) : string {
        return this.utilService.getGrado(categoria, sexo);
    }
}
